module.exports = __webpack_public_path__ + "img/award (2).8bf2c2e5.jpg";